import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { takeUntil, Subject, BehaviorSubject, switchMap } from "rxjs";
import { ProjectMetrics } from '../../../../shared/models/projects.model';
import { ProjectService } from '../../../../core/project.service';
import {toDecimal} from "ng-zorro-antd/core/util";

@Component({
  selector: 'app-project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss'],
})
export class ProjectCardComponent implements OnInit, OnDestroy {

  public loading = true;

  private _idProject: number | 'all' = 'all';
  @Input()
  set idProject(value: number | 'all') {
    this.loading = true
    this._idProject = value;
    this.idProjectSubject$.next(value);
  }
  get idProject(): number | 'all' {
    return this._idProject;
  }

  ProjectMetrics: ProjectMetrics = {} as ProjectMetrics;

  private destroy$: Subject<void> = new Subject<void>();
  private idProjectSubject$: BehaviorSubject<number | 'all'> = new BehaviorSubject<number | 'all'>(0);

  constructor(private projectService: ProjectService) {}

  ngOnInit(): void {
    this.idProjectSubject$.pipe(
      switchMap(() => this.projectService.getProjectMetrics(this.idProject)),
      takeUntil(this.destroy$)
    )
    .subscribe({
        next: (data) => {
          this.ProjectMetrics = data[0];
          this.loading = false;
        },
        error: (error) => {
          console.error(error);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  formatNumber(number: number): string {
    const formateador = new Intl.NumberFormat('es-MX', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `$${formateador.format(number)}`;
  }

  protected readonly toDecimal = toDecimal;
}
